module.exports = __webpack_public_path__ + "img/36.1.c8a14580.jpg";